import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { Subscription } from "rxjs/Subscription";
import { TransactionsStore } from "@store/transactions";
import { Contact } from "@models/contact";

@Component({
  selector: 'create-transaction-view',
  templateUrl: './create-transaction-view.pug',
})
export class CreateTransactionViewComponent implements OnInit, OnDestroy {

  private transactionSubscription: Subscription

  public debtor: Contact

  @Input() public recordTypeOfTransaction: string = null

  constructor(
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    this.transactionSubscription =
      this.store.select("transactionsReducer")
        .subscribe((s: TransactionsStore) => {
          this.debtor = s.activeDebtor
        })
  }

  clickedSelectTypeOfTransaction(targetType: string) {
    this.recordTypeOfTransaction = targetType
  }

  clickedBackToTransactionTypeSelection() {
    this.recordTypeOfTransaction = null
  }

  isTypeSelected(targetType: string): boolean {
    return this.recordTypeOfTransaction == targetType
  }

  isBackButtonVisible(): boolean {
    return ["payment", "credit", "fee"].includes(this.recordTypeOfTransaction)
  }

  ngOnDestroy() {
    this.transactionSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/create-transaction-view.ts